import { createAction, createReducer } from '@reduxjs/toolkit'

export const hydrateSlices = createAction('hydrate/slices')

const hydrationReducer = createReducer({}, builder => {
  builder.addCase(hydrateSlices, (state, action) => {
  })
})

export default hydrationReducer
